// extracted by mini-css-extract-plugin
export default {"svg":"statsComponent_svg__rwJrs"};